module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/magazine/day03_08_stay-3356b8535ff53a31625afcc89b2942c3.jpg";